// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"8251fc1f","283":"60ca4d4a","787":"73a57e67"}[chunkId] + ".chunk.js";
};